module.exports = "/images/vendor/desiigner-svg/svg/places/cristo-rei.svg?fb8d636c7927dec63abe09d8994ceefe";